import { JSONSerializable } from '../../../util/json';
import { AccAddress, ValAddress } from '../../strings';

export class MsgDelegateFeedConsent extends JSONSerializable<
  MsgDelegateFeedConsent.Data
> {
  constructor(public operator: ValAddress, public delegate: AccAddress) {
    super();
  }

  public static fromData(
    data: MsgDelegateFeedConsent.Data
  ): MsgDelegateFeedConsent {
    const {
      value: { operator, delegate },
    } = data;
    return new MsgDelegateFeedConsent(operator, delegate);
  }

  public toData(): MsgDelegateFeedConsent.Data {
    const { operator, delegate } = this;
    return {
      type: 'oracle/MsgDelegateFeedConsent',
      value: {
        operator,
        delegate,
      },
    };
  }
}

export namespace MsgDelegateFeedConsent {
  export interface Data {
    type: 'oracle/MsgDelegateFeedConsent';
    value: {
      operator: ValAddress;
      delegate: AccAddress;
    };
  }
}
